import { useLocalStorageState } from 'ahooks'

// 定义所有可能的 localStorage key 和对应的值类型
export interface LocalStorageSchema {
  'cookie-accepted': boolean
  'prev-selected-corp': {
    key: string
    name: string
  }
  'adeff-language': string
  'animation-projects': Array<{ id: number; lng: string[] }>
  'professor-rate-info': Array<{ id: number; map: Models.RateMap }>
  'knowledge-form-submit': boolean
  'experience-menu-collapsed': boolean
  'is_from': string
  'aigc-poster-debug': boolean
  // 可以继续添加其他的 key-value 对
}

/**
 * 带类型检查的 localStorage hook
 * @param key - localStorage 的键名
 * @param options - 配置项，包含默认值等
 * @returns [存储的值, 设置值的函数]
 */
export function useTypedLocalStorage<K extends keyof LocalStorageSchema>(
  key: K,
  options?: {
    defaultValue?: LocalStorageSchema[K]
    serializer?: (value: LocalStorageSchema[K]) => string
    deserializer?: (value: string) => LocalStorageSchema[K]
  }
) {
  return useLocalStorageState<LocalStorageSchema[K]>(key, options)
}
